



















































































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import { i18nMixin } from '@/modules/neodash/mixins';
import { AxiosError } from 'axios';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, IS_AUTHORIZED } from '@/store/modules/authentication/types';

import Wrapper from '@/modules/business-plan/common/business-plan-page-wrapper.component.vue';

import { ApprovalService } from '@/modules/business-plan/modules/services/approval.service';
import { EconomicGroup, Project } from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { BPA_ROUTES } from '@/modules/business-plan/router';
import { ClientEnum } from '@/enums/client.enum';
import { IKeyValue, ITextValue } from '@/interfaces/key-value-interface';
import { KeyValue } from '@/modules/neodash/model/utils/KeyValue';
import GoalStatusReport from '@/modules/business-plan/modules/approval/pages/home/goal-status-report.vue';
import { BpaStatusReport } from '@/modules/business-plan/modules/models/bpaStatusReport';
import { BpaFeaturePermission } from '@/modules/business-plan/modules/models/constants/bpa.feature.permission';
import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';

@Component({
  name: 'GoalHomePage',
  components: {
    Wrapper,
    GoalStatusReport
  }
})
export default class GoalHomePage extends Vue {
  public BpaFeaturePermission = BpaFeaturePermission;

  @Getter(IS_AUTHORIZED)
  public isAuthorized: (functionality: BpaFeaturePermission) => boolean;

  public _sessionKeyIdProject: string = '_bpaIdProjectSelected';
  public BPA_ROUTES = BPA_ROUTES;
  public readonly translate = i18nMixin.methods.i18n;
  public readonly clientEnum = ClientEnum;
  public readonly dictRoutes: { [id: number]: string; } = {
    [this.clientEnum.Toyota]: this.BPA_ROUTES.GOAL_SETTINGS_TOYOTA,
    [this.clientEnum.Ford]: this.BPA_ROUTES.GOAL_SETTINGS,
    [this.clientEnum.Volvo]: this.BPA_ROUTES.GOAL_SETTINGS_VOLVO
  };
  public groups: EconomicGroup[] = [] as EconomicGroup[];
  public sourceFamily: ITextValue<number>[] = [] as ITextValue<number>[];
  public bpaStatusReportData: Array<BpaStatusReport> = [] as BpaStatusReport[];
  public projectDataSource: IKeyValue[] = [] as IKeyValue[];
  public projectOlder: Project = {} as Project;
  public search: string = '';
  public nameLocaleType: string = '';
  public nameLocaleTypeSuperior: string = '';
  public selectedProject: any = null;
  public isStatusReportOpen: boolean = false;
  public idProjectSelected: number = 0;

  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  public get titleGoalHome(): string {
    const titles = ['Title', 'GoalSetting.Title']
      .map(x => this.translate(`BusinessPlan.${x}`))
      .join(' - ');

    return `${this.client.name} - ${titles}`;
  }

  public get filteredGroups() {
    const searchLower = this.search.toLocaleLowerCase();
    if (!searchLower)
      return this.groups;

    return this.groups.filter(x =>
      (x.nameLocaleSuperior && x.nameLocaleSuperior.toLocaleLowerCase().indexOf(searchLower) > -1)
      || (x.nameLocale.toLocaleLowerCase().indexOf(searchLower) > -1)
      || (x.nameGroup.toLocaleLowerCase().indexOf(searchLower) > -1));
  }

  public toggleStatusReportOpen() {
    this.isStatusReportOpen = !this.isStatusReportOpen;
  }

  public mounted() {
    this._requestData();
  }

  public goToGoalSettingsPage(idGroup: string, idLocale: string) {
    this.$router.push({
      name: this.dictRoutes[this.client.id],
      params: { idProject: this.idProjectSelected.toString(), idGroup: idGroup, idLocale: idLocale }
    });
  }

  public downloadPaccReport(group: EconomicGroup) {
    ApprovalService.DownloadBpaPacc(this.getClientPrefixFileName(), this.idProjectSelected, group);
  }

  public downloadBpaPaccByName(groupName: string, localeName: string) {
    ApprovalService.DownloadBpaPaccByName(this.getClientPrefixFileName(), this.projectOlder.id, groupName, localeName);
  }

  public getClientPrefixFileName() {
    if (this.client.id === ClientEnum.Volvo) {
      return 'Volvo_PAVC';
    }

    return 'Ford_PACC';
  }

  public downloadBpaConsolidate(idProject: number, isGoalRealized: boolean, reportGoalType: string | null) {
    const fileBaseName = this.client.id === this.clientEnum.Ford
      ? 'Business_Plan_Consolidação_Metas_Projetado'
      : 'Business_Plan_Consolidation_Projected_Goals';

    ApprovalService.DownloadBpaConsolidate(fileBaseName, idProject, isGoalRealized, reportGoalType);
  }

  public getGroups() {
    if (this.idProjectSelected === 0)
      return;

    ApprovalService.GetEconomicGroups(this.idProjectSelected)
      .then(groups => {
        this.groups = _(groups).orderBy(['orderLocaleSuperior', 'nameLocale'], ['asc', 'asc']).value();
        this.nameLocaleType = this.groups[0].nameLocaleType;
        this.nameLocaleTypeSuperior = this.groups[0].nameLocaleTypeSuperior;
      })
      .catch((err: AxiosError) => console.error(err.message));
  }

  private _requestData() {
    ApprovalService.GetProjects()
      .then(projects => {
        const lastProject = projects.slice(-1);

        if (lastProject.length) {
          this.idProjectSelected = lastProject[0].value;
        }

        this.projectDataSource = projects.map(x => new KeyValue(x.name, x.value));
        this.selectedProject = this.idProjectSelected;
        this.getGroups();
        traceLogAccess.logAction(ContextEnum.Bpa, `Bpa - Lista`);
      })
      .then(() => ApprovalService.GetProject(this.selectedProject))
      .then(project => ApprovalService.GetProjectByYear(project.yearReference - 1))
      .then(oldPrj => {
        this.projectOlder = oldPrj;
      })
      .then(() => {
        if (this.isAuthorized(BpaFeaturePermission.viewStatusReport)) {
          ApprovalService.ListFamilies(this.idProjectSelected)
            .then(families => {
              this.sourceFamily = families.map(x => ({ text: x.name, value: x.id }));
            })

          ApprovalService.GetBpaStatusReport(this.idProjectSelected)
            .then(data => {
              this.bpaStatusReportData = data;
            })
        }
      });
  }
}
